import { mediaList, featuredIds } from "@/mocks/media";
import type { MediaItem } from "@/types/media";

export const getMediaById = (id: string): MediaItem | undefined =>
  mediaList.find((item) => item.id === id);

export const getMovieList = (): MediaItem[] => mediaList.filter((item) => item.type === "movie");

export const getTvList = (): MediaItem[] => mediaList.filter((item) => item.type === "tv");

export const getFeaturedList = (): MediaItem[] =>
  featuredIds
    .map((id) => mediaList.find((item) => item.id === id))
    .filter((item): item is MediaItem => Boolean(item));

export const getHotList = (limit = 6): MediaItem[] =>
  [...mediaList].sort((a, b) => b.hot - a.hot).slice(0, limit);

export const getRelatedMedia = (item: MediaItem, limit = 4): MediaItem[] => {
  const scored = mediaList
    .filter((candidate) => candidate.id !== item.id)
    .map((candidate) => {
      let score = 0;
      if (candidate.type === item.type) score += 2;
      candidate.genres.forEach((genre) => {
        if (item.genres.includes(genre)) score += 3;
      });
      item.cast.forEach((actor) => {
        if (candidate.cast.includes(actor)) score += 4;
      });
      return { candidate, score };
    })
    .sort((a, b) => b.score - a.score || b.candidate.hot - a.candidate.hot);
  return scored.slice(0, limit).map((entry) => entry.candidate);
};

export const searchMedia = (keyword: string): MediaItem[] => {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return mediaList.filter((item) => {
    const haystack = [item.title, item.director, item.region, ...item.genres, ...item.cast, item.summary]
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
};

export const buildEpisodes = (item: MediaItem) => {
  if (item.type !== "tv" || item.episodeCount <= 0) return [];
  const total = Math.min(item.episodeCount, 24);
  return Array.from({ length: total }, (_unused, index) => ({
    index: index + 1,
    title: `第${index + 1}集`,
    summary: `${item.title} 第${index + 1}集：${item.summary}`,
  }));
};